/**
 * @generated SignedSource<<7023a44a2c4a409ea50ea4afcd8417bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatePickerAgenda_viewer$data = {
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly " $fragmentType": "DatePickerAgenda_viewer";
};
export type DatePickerAgenda_viewer$key = {
  readonly " $data"?: DatePickerAgenda_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatePickerAgenda_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatePickerAgenda_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b04a73f934905de2efb3241b79cadab4";

export default node;
